'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createColors = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _chromaJs = require('chroma-js');

var _chromaJs2 = _interopRequireDefault(_chromaJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var names = ['red', // 0
'orange', // 30
'yellow', // 60
'lime', // 90
'green', // 120
'teal', // 150
'cyan', // 180
'blue', // 210
'indigo', // 240
'violet', // 270
'fuschia', // 300
'pink', // 330
'red'];

var hueName = function hueName(h) {
  var i = Math.round((h - 2) / 30);
  var name = names[i];
  return name;
};

var createHues = function createHues(h) {
  return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(function (n) {
    return Math.floor((h + n * 360 / 12) % 360);
  });
};

var createColors = exports.createColors = function createColors(base) {
  var colors = {
    black: '#000',
    white: '#fff',
    darken: ['rgba(0, 0, 0, 0.125)', 'rgba(0, 0, 0, 0.25)', 'rgba(0, 0, 0, 0.5)', 'rgba(0, 0, 0, 0.75)'],
    dark: 'rgba(0, 0, 0, 0.75)',
    gray: '#eee'
  };

  var color = (0, _chromaJs2.default)(base);

  var _color$hsl = color.hsl(),
      _color$hsl2 = _slicedToArray(_color$hsl, 3),
      hue = _color$hsl2[0],
      sat = _color$hsl2[1],
      lite = _color$hsl2[2];

  var hues = createHues(hue);
  hues.forEach(function (h) {
    var name = hueName(h);
    var val = _chromaJs2.default.hsl(h, sat, lite);
    colors[name] = val.hex();
  });

  return colors;
};

var colors = createColors('#06e');

exports.default = colors;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rebass/dist/colors.js
// module id = 242
// module chunks = 0